import RPMPatientLogs from './patient-logs';
import './patient-logs.css';

export default RPMPatientLogs;
